import React from "react";
import { Link } from "react-router-dom";
import ConsultationAreaForm from "../../components/Consultation/ConsultationAreaForm";
import ConsultationForm from "./Consulation_form";




const WebBAnner = ({index, content, title}) => {
  return (
    <section className="banner-area " style={{paddingTop: "8rem"}}>
      <div className="container">
        <div className="row align-items-center res-consulation-form" style={{flexDirection: "row-reverse"}}>
          <div className="col-lg-6" style={{display: "flex", justifyContent: "end"}}>
            {/* <div className="banner-img wow fadeInLeft" data-wow-delay=".4s">
            
            </div> */}
            <ConsultationForm />
          </div>
          <div className="col-lg-6">
            <div className="banner-content">
              <span className="bread-crumb wow fadeInUp" data-wow-delay=".2s">
                Home <span className="dot">{">"}</span> <strong> Services </strong><span className="dot">{">"}</span> {title}
              </span>
              <h1
                className="title wow fadeInUp"
                data-wow-delay=".4s"
                style={{ marginBottom: "12px", fontSize: "2.6rem" }}
              >
                {/* {content[index].main_title_one}<span className="design-style">{content[index].title_into_light}</span>{content[index].main_title_two} */}
                {content.h1}
                </h1>
              <p style={{ marginBottom: "25px" }}>
                {/* {content[index].main_para} */}
                {content.para}
              </p>
              {/* <div className="">
                <ul className="list-wrap" style={{display: "flex", flexDirection: "column", gap: ".8rem"}}>
                  <li style={{display: "flex", gap: ".4rem"}}>
                    <img src="/img/icon/check_icon.png" alt="" />
                    Seo quotes to inspire your campaign
                  </li>
                  <li style={{display: "flex", gap: ".4rem"}}>
                    <img src="/img/icon/check_icon.png" alt="" />
                    Much easier to double your business
                  </li>
                  <li style={{display: "flex", gap: ".4rem"}}>
                    <img src="/img/icon/check_icon.png" alt="" />
                    Free page speed insights tool to find out exactly
                  </li>
                  <li style={{display: "flex", gap: ".4rem"}}>
                    <img src="/img/icon/check_icon.png" alt="" />
                    Seo quotes to inspire your campaign
                  </li>
                </ul>
              </div> */}
              <div className="margin-1 res-banner-container">
              <Link
                to="/portfolio"
                className="btn wow fadeInUp"
                data-wow-delay=".6s"
              >
                Portfolio <span></span>
              </Link>
              <Link
                to="/contact"
                className="btn wow fadeInUp"
                data-wow-delay=".6s"
              >
                Contact Us <span></span>
              </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="banner-shape-wrap">
        <img src="/img/banner/banner_shape01.png" alt="" />
        <img
          src="/img/banner/banner_shape02.png"
          alt=""
          className="animationFramesOne"
        />
        <img
          src="/img/banner/banner_shape03.png"
          alt=""
          className="contactSwimmer"
        />
        <img src="/img/banner/banner_shape04.png" alt="" className="rotateme" />
        <img
          src="/img/banner/banner_shape05.png"
          alt=""
          className="animation1"
        />
        <img
          src="/img/banner/banner_shape06.png"
          alt=""
          className="ribbonRotate"
        />
        <img
          src="/img/banner/banner_shape07.png"
          alt=""
          className="float-bob-x"
        />
      </div> */}
    </section>
  );
};

export default WebBAnner;
